import styled from 'styled-components';
import {ScreenSizes} from '../../../types/responsive';
import {StyledDiv} from '../StyledSx';

export const MainTitleContent = styled(StyledDiv)`
  padding-top: 90px;
  max-width: 590px;

  @media (max-width: ${ScreenSizes.lg}) {
    top: 70px;
  }
  @media (max-width: ${ScreenSizes.md}) {
    padding-top: 0;
    max-width: 100%;
  }
  @media (max-width: ${ScreenSizes.sm}) {
    padding-top: 10px;
  }
`;
